import { render, staticRenderFns } from "./v_Terms_TermsOfUse.vue?vue&type=template&id=f309cf3e&scoped=true&"
import script from "./v_Terms_TermsOfUse.vue?vue&type=script&lang=js&"
export * from "./v_Terms_TermsOfUse.vue?vue&type=script&lang=js&"
import style0 from "./v_Terms_TermsOfUse.vue?vue&type=style&index=0&id=f309cf3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f309cf3e",
  null
  
)

export default component.exports